import Router from 'next/router';

function redirect({ ctx, destination, status = 307 }) {
  const { res } = ctx;
  if (res) {
    const basePath = process.env.BASE_PATH || '';
    res.writeHead(status, {
      Location: `${basePath}${destination}`,
      'Content-Type': 'text/html; charset=utf-8',
    });
    res.end();
  } else {
    Router.replace(destination);
  }
}

export default redirect;
